import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Ripple } from "primereact/ripple";
import { Toast } from "primereact/toast";
import { DataTable } from "primereact/datatable";
import { Column, ColumnEvent } from "primereact/column";
import { ColumnGroup } from "primereact/columngroup";
import { Row } from "primereact/row";
import { Button } from "primereact/button";
import { InputNumber } from "primereact/inputnumber";
import {
  Dropdown,
  DropdownChangeEvent,
  DropdownProps,
} from "primereact/dropdown";
import { Dialog } from "primereact/dialog";
import { Checkbox } from "primereact/checkbox";
import { getAppCurrencyType } from "../../../../../../Utils/Common";

import { goToTop } from "../../../../../../Components/goToTop";
import NoteViewModal from "../NoteViewModal";
import { InputTextarea } from "primereact/inputtextarea";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../../Controllers/hooks";
import {
  ProjectTenderDetailInterface,
  TenderListInterface,
  TenderShareContact,
} from "../../../../../../Controllers/Types/Tender/projectTenderDetailsInterface";
import {
  Priliminary,
  SowSection,
  SowSectionItemData,
  SowSubSection,
  SowSubSectionItemData,
} from "../../../../../../Controllers/Types/Tender/tenderSow";

import { formatPrice } from "../../../../../../Utils/getDate";
import DocumentDownload from "../../../Onsite/ValuationEdit/DocumentDownload";
import {
  getSowFileForDownload,
  setValueFromTederListEdit,
  setValueFromTederListEditPremi,
} from "../../../../../../Api/tenderApi";
import { ShowToast } from "../../../../../../Components/ShowToast";
import { setContactListForComparePrice } from "../../../../../../Controllers/Slices/tenderSlice";
import { getProjectTenderDetailList } from "../../../../../../Controllers/Thunks/tenderThunks";
import { InputText } from "primereact/inputtext";

const TenderList: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const currencySymbol = getAppCurrencyType();

  // const { contactListForComparePrice } = useAppSelector(
  //   (state) => state.tender
  // );

  const toast = useRef<Toast>(null);

  const [dataState, setDataState] = useState<"Add" | "Edit">("Add");
  const [loading, setLoading] = useState<boolean>(false);
  const [successMessage, setSuccessMessage] = useState<string>("");
  const [showSideBar, setShowSideBar] = useState<boolean>(false);
  const [showDownloadModal, setShowDownloadModal] = useState<boolean>(false);
  const [showDownloadLoading, setShowDownloaLoading] = useState<boolean>(false);
  const [downloadFilePath, setDownloadFilePath] = useState<string>("");

  /* Cover page */
  const [showCoverPage, setShowCoverpage] = useState<boolean>(true);
  const [coverPageData, setCoverPageData] = useState<string | null>(null);

  /* Contents */
  const [sectionData, setSectionData] = useState<SowSection[]>([]);
  const [showContent, setShowContent] = useState<boolean>(false);
  const [hasSection, setHasSection] = useState<boolean>(false);

  /* Sub section */
  const [showSubSection, setShowSubSection] = useState<boolean>(false);
  const [currentSection, setCurrentSection] = useState<SowSection | null>(null);
  const [hasSubSection, setHasSubSection] = useState<boolean>(false);

  /* Section item */
  const [hasSectionItem, setHasSectionItem] = useState<boolean>(false);

  /* Sub section item */
  const [currentSubSection, setCurrentSubSection] =
    useState<SowSubSection | null>(null);
  const [showSubSectionItem, setShowSubSectionItem] = useState<boolean>(false);
  const [subSectionItem, setSubSectionItem] = useState<boolean>(false);

  /* Preliminaries */
  const [showPreliminaries, setShowPreliminaries] = useState<boolean>(false);
  const [preliminariesData, setPreliminariesData] = useState<Priliminary[]>([]);
  const [hasPreliminary, setHasPreliminary] = useState<boolean>(false);

  /* Company */
  const [buildersList, setbuildersList] = useState<TenderListInterface[]>([]);
  const [selectedBuilderData, setSelectedBuilderData] =
    useState<TenderListInterface | null>(null);

  /* Note */
  const [showNoteViewModal, setShowNoteViewModal] = useState<boolean>(false);
  const [note, setNote] = useState<string>("");

  /* Compare */
  const [showCompareModal, setShowCompareModal] = useState<boolean>(false);
  const [checkedCompareBuilders, setCheckedCompareBuilders] = useState<
    TenderListInterface[]
  >([]);

  const [loginUserRoleName, setLoginUserRoleName] = useState<string>("");
  const [UserId, setUserId] = useState<string>("");
  const [isEditable, setIsEditable] = useState<boolean>(false);
  const [isFixed, setIsFixed] = useState<boolean>(false);

  //    need to tiggere and reset tende detail and tender list informations as well.

  const tenderPartFromState = location.state as ProjectTenderDetailInterface;

  const [tenderPart, setTenderPart] =
    useState<ProjectTenderDetailInterface | null>(null);

  const [tenderList, setTenderList] = useState<TenderListInterface[]>([]);

  const [contatList, setcontatList] = useState<TenderShareContact[]>([]);
  const [activeContact, setActiveContact] = useState<TenderShareContact | null>(
    null
  );

  //   const tenderList: TenderListInterface[] = tenderPartFromState.tender_list;

  useEffect(() => {
    dispatch(getProjectTenderDetailList(tenderPartFromState.folder_id));
    setcontatList(tenderPartFromState?.share_contact!);
  }, []);

  // get active contact of the list
  useEffect(() => {
    const userId = localStorage.getItem("user_id");
    if (contatList && tenderPart !== null) {
      const listData = contatList.filter(
        (e) => String(e.login_user_id) === userId
      );
      if (listData && listData.length > 0) {
        setActiveContact(listData[0]);
      }
    }
  }, [contatList]);

  // login user type name.
  useEffect(() => {
    const fetchUserRoleName = async () => {
      try {
        const userTypeName = await Promise.resolve(
          localStorage.getItem("user_type_name")
        );

        if (userTypeName) {
          setLoginUserRoleName(userTypeName.toLowerCase());
        } else {
          setLoginUserRoleName("");
        }
      } catch (error) {
        setLoginUserRoleName("");
        setUserId("0");
      }
    };

    fetchUserRoleName();
  }, []);

  // this is get data from state list and set projectlist
  const tenderDetails = useAppSelector(
    (state) => state.tender.projectTenderDetail
  );

  useEffect(() => {
    const data = tenderDetails.filter(
      (e) =>
        e.project_tender_part_id === tenderPartFromState.project_tender_part_id
    );
    if (data && data.length > 0) {
      setTenderPart(data[0]);
    }
  }, [tenderDetails]);

  useEffect(() => {
    setTenderList(tenderPart?.tender_list!);
  }, [tenderPart]);

  //   selected active contact with tender list reset
  useEffect(() => {
    // set active tender list only view
    if (tenderList && tenderList.length > 0) {
      const maintnder = tenderList.filter((e) => e.fixed_tender_list === 1);
      if (maintnder && maintnder.length > 0) {
        // fixed tender list
        // not edit any one
        // display only fixed tender data.
        setSelectedBuilderData(maintnder[0]);
        setIsFixed(true);
        setIsEditable(false);

      } else {
        if (tenderList) {
          const dataa = tenderList.filter(
            (e) => e.tender_part_share_id === activeContact?.tender_part_share_id
          );
          if (dataa && dataa.length > 0) {
            setSelectedBuilderData(dataa[0]);
          } else {
            if (tenderList && tenderList.length > 0) {
              setSelectedBuilderData(tenderList[0]);
            }
          }
        }
      }
    }

  }, [tenderList]);

  // edit or delete handle.
  useEffect(() => {
    if (loginUserRoleName === "builder" && isFixed === false) {
      setIsEditable(true);
    } else {
      setIsEditable(false);
    }
  }, [loginUserRoleName]);

  //   this is for an architect
  useEffect(() => {
    if (tenderList.length > 0) {
      if (loginUserRoleName === "Architect") {
        setSelectedBuilderData(tenderList[0]);
      } else {
        // const tenderlistData=tenderList.filter((e)=>e.tender_part_share_id===)
      }

      // this is for calling actions.
      dispatch(setContactListForComparePrice(tenderList));
    }
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      if (selectedBuilderData != null) {
        setCoverPageData(selectedBuilderData.cover_page || null);
        setSectionData(selectedBuilderData?.section_data || []);
        setPreliminariesData(selectedBuilderData?.priliminiery_data || []);
      }

      //setbuildersList(builders)
    };
    fetchData();
  }, [selectedBuilderData]);

  /* *************************************************************************** */

  /* ******************************** Cover page ******************************** */
  const handleShowCoverPage = () => {
    setShowCoverpage(true);
    scrollToSection("coverPage");

    setShowContent(false);
    setShowSubSection(false);
    setShowPreliminaries(false);
    setShowSubSectionItem(false);
  };
  /* **************************************************************************** */

  /* ********************************* Section ********************************* */
  useEffect(() => {
    const checkSectionHasData = () => {
      if (sectionData.length > 0) {
        setHasSection(true);
      } else {
        setHasSection(false);
      }
    };

    checkSectionHasData();
  }, [sectionData]);

  const handleShowSection = () => {
    setShowContent(true);
    scrollToSection("content");

    setShowCoverpage(false);
    setShowSubSection(false);
    setShowPreliminaries(false);
    setShowSubSectionItem(false);
  };
  /* *************************************************************************** */

  /* ******************************* Sub Section ******************************* */
  const handleShowSubSection = async (section: SowSection) => {
    setCurrentSection(section);
    scrollToSection(`section${section?.section_no}`);

    if (section?.sub_section_data?.length !== 0) {
      setHasSubSection(true);
    } else {
      setHasSubSection(false);
    }

    if (section?.section_item_data?.length !== 0) {
      setHasSectionItem(true);
    } else {
      setHasSectionItem(false);
    }

    setShowSubSection(true);

    setShowContent(false);
    setShowCoverpage(false);
    setShowPreliminaries(false);
    setShowSubSectionItem(false);
  };
  /* *************************************************************************** */

  /* **************************** Sub section item ***************************** */
  const handleShowSubSectionItem = async (subSection: SowSubSection) => {
    setCurrentSubSection(subSection);
    scrollToSection(`subsection${subSection?.sub_section_no}`);

    if (subSection?.sub_section_item_data?.length !== 0) {
      setSubSectionItem(true);
    } else {
      setSubSectionItem(false);
    }

    setShowSubSectionItem(true);
    setShowContent(false);
    setShowCoverpage(false);
    setShowPreliminaries(false);
    setShowSubSection(false);
  };

  const subSectionItemEditor = (options: any) => {
    switch (options?.field) {
      case "unit_no":
        return (
          <InputNumber
            value={options.value}
            // onValueChange={(e: InputNumberValueChangeEvent) => options.editorCallback(e.value)}
            onChange={(e) => options.editorCallback(e.value)}
            onKeyDown={(e) => e.stopPropagation()}
            mode="decimal"
            className="editable_number_input"
            useGrouping={false}
            inputClassName="text-center"
          />
        );
      case "unit_price":
        return (
          <InputNumber
            value={options.value}
            // onValueChange={(e: InputNumberValueChangeEvent) => options.editorCallback(e.value)}
            onChange={(e) => options.editorCallback(e.value)}
            onKeyDown={(e) => e.stopPropagation()}
            mode="decimal"
            className="editable_number_input"
            useGrouping={true}
            minFractionDigits={2}
            maxFractionDigits={2}
            prefix={currencySymbol + " "}
            inputClassName="text-center"
          />
        );
      case "note":
        return (
          <InputTextarea
            value={options.value}
            // onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => options.editorCallback(e.target.value)}
            onChange={(e) => options.editorCallback(e.target.value)}
            onKeyDown={(e) => e.stopPropagation()}
            rows={2}
            className="editable_text_input text-center"
          />
        );
      default:
        return null;
    }
  };

  const subSectionItemEditComplete = async (e: ColumnEvent) => {
    const { rowData, newValue, field, originalEvent: event } = e;

    if (Object.prototype.hasOwnProperty.call(rowData, field)) {
      rowData[field] = newValue;
    } else {
      // const updatedRow = { ...rowData, [field]: newValue };
      if (String(newValue) !== "undefined") {
        const data = await setValueFromTederListEdit(
          rowData.item_id,
          selectedBuilderData?.tender_part_share_id!,
          field,
          String(newValue)
        );

        setLoading(false);
        if (data.status === true) {
          // call shop dispach event
          dispatch(getProjectTenderDetailList(tenderPartFromState.folder_id));
        }
      }

      event.preventDefault();
    }
  };

  /* **************************************************************************** */

  /* ****************************** Section item ******************************* */
  const sectionItemEditor = (options: any) => {
    switch (options?.field) {
      case "unit_no":
        return (
          <InputNumber
            value={options.value}
            onChange={(e) => options.editorCallback(e.value)}
            onKeyDown={(e) => e.stopPropagation()}
            mode="decimal"
            className="editable_number_input"
            useGrouping={false}
            inputClassName="text-center"
          />
        );
      case "unit_price":
        return (
          <InputNumber
            value={options.value}
            onChange={(e) => options.editorCallback(e.value)}
            onKeyDown={(e) => e.stopPropagation()}
            mode="decimal"
            className="editable_number_input"
            useGrouping={true}
            minFractionDigits={2}
            maxFractionDigits={2}
            prefix={currencySymbol + " "}
            inputClassName="text-center"
          />
        );
      case "note":
        return (
          <InputTextarea
            value={options.value}
            onChange={(e) => options.editorCallback(e.target.value)}
            onKeyDown={(e) => e.stopPropagation()}
            rows={2}
            className="editable_text_input text-center"
          />
        );
      default:
        return null;
    }
  };

  const sectionItemEditComplete = async (e: ColumnEvent) => {
    const { rowData, newValue, field, originalEvent: event } = e;
    if (Object.prototype.hasOwnProperty.call(rowData, field)) {
      rowData[field] = newValue;
    } else {
      // const updatedRow = { ...rowData, [field]: newValue };
      if (String(newValue) !== "undefined") {
        const data = await setValueFromTederListEdit(
          rowData.item_id,
          selectedBuilderData?.tender_part_share_id!,
          field,
          String(newValue)
        );

        setLoading(false);
        if (data.status === true) {
          // call shop dispach event
          dispatch(getProjectTenderDetailList(tenderPartFromState.folder_id));
        }
      }

      event.preventDefault();
    }
  };
  /* *************************************************************************** */

  /* ****************************** Preliminaries ******************************* */
  useEffect(() => {
    const checkPreliminaryHasData = () => {
      if (preliminariesData.length > 0) {
        setHasPreliminary(true);
      } else {
        setHasPreliminary(false);
      }
    };
    checkPreliminaryHasData();
  }, [preliminariesData]);

  const handleShowPreliminaries = () => {
    setShowPreliminaries(true);
    scrollToSection("preliminary");

    setShowContent(false);
    setShowCoverpage(false);
    setShowSubSection(false);
    setShowSubSectionItem(false);
  };

  const preliminaryItemEditor = (options: any) => {
    switch (options?.field) {
      case "unit_no":
        return (
          <InputNumber
            value={options.value}
            onChange={(e) => options.editorCallback(e.value)}
            onKeyDown={(e) => e.stopPropagation()}
            mode="decimal"
            className="editable_number_input"
            useGrouping={false}
            inputClassName="text-center"
          />
        );
      case "unit_price":
        return (
          <InputNumber
            value={options.value}
            onChange={(e) => options.editorCallback(e.value)}
            onKeyDown={(e) => e.stopPropagation()}
            mode="decimal"
            className="editable_number_input"
            useGrouping={true}
            minFractionDigits={2}
            maxFractionDigits={2}
            prefix={currencySymbol + " "}
            inputClassName="text-center"
          />
        );
      case "note":
        return (
          <InputTextarea
            value={options.value}
            onChange={(e) => options.editorCallback(e.target.value)}
            onKeyDown={(e) => e.stopPropagation()}
            rows={2}
            className="editable_text_input text-center"
          />
        );
      default:
        return null;
    }
  };

  const preliminaryItemEditComplete = async (e: ColumnEvent) => {
    const { rowData, newValue, field, originalEvent: event } = e;

    if (Object.prototype.hasOwnProperty.call(rowData, field)) {
      rowData[field] = newValue;
    } else {
      // const updatedRow = { ...rowData, [field]: newValue };
      if (String(newValue) !== "undefined") {
        const data = await setValueFromTederListEditPremi(
          rowData.priliminiery_id,
          selectedBuilderData?.tender_part_share_id!,
          field,
          String(newValue)
        );

        setLoading(false);
        if (data.status === true) {
          // call shop dispach event
          dispatch(getProjectTenderDetailList(tenderPartFromState.folder_id));
        }
      }

      event.preventDefault();
    }
  };
  /* **************************************************************************** */

  /* **************************** Common functions ***************************** */
  const handleViewNote = (noteContent: string) => {
    setShowNoteViewModal(true);
    setNote(noteContent);
  };

  const handleCloseNoteView = () => {
    setShowNoteViewModal(false);
    setNote("");
  };
  const handleShowDownload = async () => {
    setShowDownloaLoading(true);
    const res = await getSowFileForDownload(
      tenderPartFromState.project_tender_part_id
    );
    setShowDownloaLoading(false);

    if (res.status) {
      setDownloadFilePath(res.body.path);
      setShowDownloadModal(true);
    } else {
      ShowToast(toast, "error", "Failed", "Download faiiled");
    }
  };

  const handleHideDownload = () => {
    setShowDownloadModal(false);
  };

  const scrollToSection = (id: string) => {
    const section = document.getElementById(id);
    if (section) {
      const yOffset = -150;
      const yPosition =
        section.getBoundingClientRect().top + window.pageYOffset + yOffset;

      window.scrollTo({ top: yPosition, behavior: "smooth" });
    }
  };

  const goBack = () => {
    navigate(-1);
    goToTop();
  };

  const handleShowSideBar = () => {
    setShowSideBar(!showSideBar);
  };

  const getRowClassName = () => {
    return "project_table_row";
  };
  /* *************************************************************************** */

  // calculate subtotal for unit price
  const calculateSectionItemUnitPriceTotal = (items: SowSectionItemData[]) => {
    return items.reduce(
      (acc, item) => acc + (item.item_amount_data!.unit_price ?? 0),
      0
    );
  };

  const calculateSectionItemPriceTotal = (items: SowSectionItemData[]) => {
    return items.reduce(
      (acc, item) => acc + (item.item_amount_data!.total ?? 0),
      0
    );
  };

  const calculateSubSectionItemUnitPriceTotal = (
    items: SowSubSectionItemData[]
  ) => {
    return items.reduce(
      (acc, item) => acc + (item.item_amount_data!.unit_price ?? 0),
      0
    );
  };

  const calculateSubSectionItemPriceTotal = (
    items: SowSubSectionItemData[]
  ) => {
    return items.reduce(
      (acc, item) => acc + (item.item_amount_data!.total ?? 0),
      0
    );
  };

  const calculatePriliminaryItemUnitPriceTotal = (items: Priliminary[]) => {
    return items.reduce(
      (acc, item) => acc + (item.priliminiery_amount_data!.unit_price ?? 0),
      0
    );
  };

  const calculatePriliminaryItemPriceTotal = (items: Priliminary[]) => {
    return items.reduce(
      (acc, item) => acc + (item.priliminiery_amount_data!.total ?? 0),
      0
    );
  };

  // const unitPriceTotalPreliminaries = calculateUnitPriceTotal(preliminariesData);
  // const multiplePriceTotalPreliminaries = calculateMultiplePriceTotal(preliminariesData);

  const unitPriceTotalPreliminaries =
    calculatePriliminaryItemUnitPriceTotal(preliminariesData);
  const multiplePriceTotalPreliminaries =
    calculatePriliminaryItemPriceTotal(preliminariesData);

  /* ******************************** Compare ******************************** */
  const handleCompareTenderList = () => {
    setShowCompareModal(true);
  };

  const handleComparePrices = () => {
    setShowCompareModal(false);
    navigate(
      "/project/detail/default-service/pre-commencement/tender/tender-list/compare",
      { state: { tenderList: checkedCompareBuilders, tenderpart: tenderPart } }
    );
  };

  const handleCloseCompareModal = () => {
    setShowCompareModal(false);
    setCheckedCompareBuilders([]);
  };

  /* Compare modal header */
  const compareModalHeader = (
    <div className="custom_modal_header_inner">
      <h5 className="modal-title fs-5">Compare price</h5>
      <button
        type="button"
        className="close_modal_btn p-ripple"
        onClick={handleCloseCompareModal}
      >
        <i className="bi bi-x-circle"></i>
        <Ripple />
      </button>
    </div>
  );

  /* compare modal footer */
  const compareModalFooter = (
    <div className="custom_modal_footer">
      <Button
        label={`Compare`}
        onClick={handleComparePrices}
        className="custom_btn primary"
        disabled={checkedCompareBuilders?.length < 2}
      />
    </div>
  );

  const handleCheckToCompare = (
    builder: TenderListInterface,
    isChecked: boolean
  ) => {
    if (isChecked) {
      setCheckedCompareBuilders((prevState) => [...prevState, builder]);
    } else {
      setCheckedCompareBuilders((prevState) =>
        prevState.filter(
          (existingBuilder) =>
            existingBuilder.tender_part_share_id !==
            builder.tender_part_share_id
        )
      );
    }
  };

  const isCheckedCompare = (builder: TenderListInterface) =>
    checkedCompareBuilders.some(
      (existingBuilder) =>
        existingBuilder.tender_part_share_id === builder.tender_part_share_id
    );
  /* **************************************************************************** */

  const sectionValueTemplate = (
    value: TenderListInterface,
    props: DropdownProps
  ) => {
    if (value) {
      return (
        <div className="d-flex gap-3 align-items-center">
          {
            <div>
              {value?.company_name !== null
                ? value?.company_name
                : value.first_name}
            </div>
          }
        </div>
      );
    }
    return <span>{props.placeholder}</span>;
  };

  const sectionOptionsTemplate = (section: TenderListInterface) => {
    return (
      <div className="d-flex align-items-center w-100 justify-content-between">
        {
          <div>
            {section.company_name !== null
              ? section.company_name
              : section.first_name}
          </div>
        }
      </div>
    );
  };

  return (
    <div>
      <div className="project_toolbar">
        <Button
          icon={`bi ${showSideBar ? "bi-arrow-left" : "bi-list"}`}
          onClick={handleShowSideBar}
          className="sidebar_toggle_btn"
        />

        <div className="project_tool_options custom_flex">
          <div className="project_tool_options_sub">
            {!showPreliminaries &&
              ((loginUserRoleName === "architect" ||
                loginUserRoleName === "commercial client") && isFixed === false) && (
                <button
                  className={`is_btn project_tool_btn p-ripple`}
                  onClick={handleCompareTenderList}
                >
                  Compare
                  <Ripple />
                </button>
              )}
          </div>

          <div className="project_tool_options_sub dynamic_width">
            <div className="page_form_group mb-0 w-100">
              {(isFixed === true) ? (<InputText
                readOnly
                className="text-center text-success"
                value={
                  selectedBuilderData?.company_name !== null
                    ? selectedBuilderData?.company_name
                    : selectedBuilderData?.first_name +
                    " " +
                    selectedBuilderData?.last_name
                }
              />) : ((loginUserRoleName === "architect" ||
                loginUserRoleName === "commercial client")) ? (
                <Dropdown
                  id="selectedBuilderData"
                  value={selectedBuilderData}
                  onChange={(e: DropdownChangeEvent) => {
                    setSelectedBuilderData(e.value);
                  }}
                  options={tenderList}
                  valueTemplate={sectionValueTemplate}
                  itemTemplate={sectionOptionsTemplate}
                  optionLabel="tender_part_share_id"
                  placeholder="Select builder"
                  className="form_dropdown w-100"
                />
              ) : (
                <InputText
                  readOnly
                  className="text-center"
                  value={
                    selectedBuilderData?.company_name !== null
                      ? selectedBuilderData?.company_name
                      : selectedBuilderData?.first_name +
                      " " +
                      selectedBuilderData?.last_name
                  }
                />
              )}
            </div>
          </div>

          <div className="project_tool_options_sub">
            <button
              className={`is_btn project_tool_btn p-ripple`}
              onClick={handleShowDownload}
              disabled={showDownloadLoading}
            >
              {showDownloadLoading ? "Loading.." : "Download"}
              {!showDownloadLoading && <Ripple />}
            </button>
            <button
              className={`is_btn project_tool_btn p-ripple`}
              onClick={goBack}
            >
              Back
              <Ripple />
            </button>
          </div>
        </div>
      </div>

      <div className={`project_sidebar ${showSideBar ? "show" : ""}`}>
        <ul className="section_list">
          {/* Cover page */}
          <li className="section_list_item">
            <div className={`section_link_grp ${showCoverPage && "active"}`}>
              <i
                className={`bi bi-caret-right-fill section_link_icon ${coverPageData === null && "disabled"
                  }`}
              ></i>
              <button
                className="section_link is_btn"
                disabled={coverPageData === null}
                onClick={handleShowCoverPage}
              >
                <span>Cover page</span>
              </button>
            </div>
          </li>

          {/* Contents */}
          <li className="section_list_item">
            <div
              className={`section_link_grp ${showContent && "active"} ${sectionData?.length > 0 && "has_child"
                } `}
            >
              <i
                className={`bi bi-caret-right-fill section_link_icon ${sectionData?.length === 0 && "disabled"
                  }`}
              ></i>
              <button
                className="section_link is_btn"
                disabled={sectionData?.length === 0}
                onClick={handleShowSection}
              >
                <span>Contents</span>
              </button>
            </div>

            {sectionData?.length > 0 && (
              <ul className="section_sub_list">
                {sectionData?.map((section) => (
                  <li
                    key={section.section_id}
                    className="section_sub_list_item"
                  >
                    <div
                      className={`section_link_grp ${showSubSection &&
                        section.section_id === currentSection?.section_id &&
                        "active"
                        } ${section?.sub_section_data?.length! > 0 && "has_child"
                        } `}
                    >
                      <i
                        className={`bi bi-caret-right section_link_icon ${section?.sub_section_data?.length === 0 &&
                          section?.section_item_data?.length === 0 &&
                          "disabled"
                          }`}
                      ></i>
                      <button
                        className="section_link is_btn"
                        disabled={
                          section?.sub_section_data?.length === 0 &&
                          section?.section_item_data?.length === 0
                        }
                        onClick={() => handleShowSubSection(section)}
                      >
                        <span>{section.section_name}</span>
                      </button>
                    </div>

                    {section?.sub_section_data?.length! > 0 && (
                      <ul className="section_sub_list_sub">
                        {section.sub_section_data?.map((sub_section) => (
                          <li
                            className="section_sub_list_item_sub"
                            key={sub_section.sub_section_id}
                          >
                            <div
                              className={`section_link_grp ${showSubSectionItem &&
                                sub_section.sub_section_id ===
                                currentSubSection?.sub_section_id &&
                                "active"
                                } `}
                            >
                              <small
                                className={`${sub_section?.sub_section_item_data?.length ===
                                  0 && "disabled"
                                  }`}
                              >
                                {sub_section.sub_section_no}
                              </small>
                              <button
                                className="section_link is_btn"
                                disabled={
                                  sub_section?.sub_section_item_data?.length ===
                                  0
                                }
                                onClick={() =>
                                  handleShowSubSectionItem(sub_section)
                                }
                              >
                                <span>{sub_section.sub_section_name}</span>
                              </button>
                            </div>
                          </li>
                        ))}
                      </ul>
                    )}
                  </li>
                ))}
              </ul>
            )}
          </li>

          {/* Preliminaries */}
          <li className="section_list_item">
            <div
              className={`section_link_grp ${showPreliminaries && "active"} `}
            >
              <i
                className={`bi bi-caret-right-fill section_link_icon ${preliminariesData?.length === 0 && "disable d"
                  }`}
              ></i>
              <button
                className="section_link is_btn"
                disabled={preliminariesData?.length === 0}
                onClick={handleShowPreliminaries}
              >
                <span>Preliminaries</span>
              </button>
            </div>
          </li>
        </ul>
      </div>

      <div
        className={`layout_backdrop ${showSideBar ? "show" : ""}`}
        onClick={handleShowSideBar}
      ></div>

      <div
        className={`project_main_content ${showSideBar ? "has_sidebar" : ""}`}
      >
        {coverPageData !== null && (
          <article
            id="coverPage"
            className="main_section_area d-flex"
            style={{ minHeight: "60vh" }}
          >
            <div className="cover_page_area">
              <h2>{"Schedule of work"}</h2>
              <h6>{coverPageData}</h6>
              <h5>At</h5>
              <h5>{tenderPart?.project_address}</h5>
              <br />
              <h5>
                For <br />
                {tenderPart?.company_name}
              </h5>
            </div>
          </article>
        )}

        {sectionData?.length > 0 && (
          <article id="content" className="main_section_area">
            <div className="main_section_header">
              <h6>Contents</h6>
            </div>

            <DataTable
              value={sectionData}
              size="small"
              tableStyle={{ minWidth: "50rem" }}
              className="page_table project_table view_only p-0 p-sm-2"
              tableClassName="mb-1"
              rowClassName={getRowClassName}
              scrollable
              scrollHeight={"75vh"}
              emptyMessage="No data found"
            >
              <Column
                header="Section no"
                alignHeader={"center"}
                body={(rowData: SowSection) =>
                  rowData.section_no ? (
                    <span className="flex_center">{rowData.section_no}</span>
                  ) : (
                    "--"
                  )
                }
                style={{ width: "15%" }}
                className="table_column"
              ></Column>
              <Column
                header="Content"
                body={(rowData: SowSection) =>
                  rowData.section_name ? (
                    <span>{rowData.section_name}</span>
                  ) : (
                    "--"
                  )
                }
                style={{ width: "65%" }}
                className="table_column"
              ></Column>
              <Column
                header="Price"
                alignHeader={"right"}
                body={(rowData: SowSection) =>
                  rowData.section_amount !== null ? (
                    <span className="flex-end text-end text_no_wrap price_text">
                      {currencySymbol}&nbsp;
                      {formatPrice(rowData.section_amount!)}
                    </span>
                  ) : (
                    "--"
                  )
                }
                style={{ width: "20%" }}
                className="table_column text-end"
              ></Column>
            </DataTable>
          </article>
        )}

        {sectionData.map((section) => {
          // const unitPriceTotalSection = calculateUnitPriceTotal(section?.section_item_data || []);
          // const multiplePriceTotalSection = calculateMultiplePriceTotal(section?.section_item_data || []);

          const unitPriceTotalSection = calculateSectionItemUnitPriceTotal(
            section.section_item_data
          );
          const multiplePriceTotalSection = calculateSectionItemPriceTotal(
            section.section_item_data
          );

          return (
            <React.Fragment>
              {section?.sub_section_data?.length !== 0 && (
                <React.Fragment>
                  <article
                    id={`section${section?.section_no}`}
                    key={section.section_id}
                    className="main_section_area"
                  >
                    <div className="main_section_header">
                      <h6>
                        {section?.section_no}. {section?.section_name}
                      </h6>
                    </div>
                    <DataTable
                      value={section?.sub_section_data}
                      size="small"
                      tableStyle={{ minWidth: "50rem" }}
                      className="page_table project_table view_only p-0 p-sm-2"
                      tableClassName="mb-1"
                      rowClassName={getRowClassName}
                      scrollable
                      scrollHeight={"75vh"}
                      emptyMessage="No data found"
                    >
                      <Column
                        header="Sub section no."
                        alignHeader={"center"}
                        body={(rowData) =>
                          rowData.sub_section_no ? (
                            <span className="flex_center">
                              {rowData.sub_section_no}
                            </span>
                          ) : (
                            "--"
                          )
                        }
                        style={{ width: "15%" }}
                        className="table_column"
                      ></Column>

                      <Column
                        header="Sub section name"
                        body={(rowData) =>
                          rowData.sub_section_name ? (
                            <span>{rowData.sub_section_name}</span>
                          ) : (
                            "--"
                          )
                        }
                        style={{ width: "65%" }}
                        className="table_column"
                      ></Column>

                      <Column
                        header="Price"
                        alignHeader={"right"}
                        body={(rowData) =>
                          rowData.sub_section_amount !== null ? (
                            <span className="flex-end text-end text_no_wrap price_text">
                              {currencySymbol}&nbsp;
                              {formatPrice(rowData.sub_section_amount)}
                            </span>
                          ) : (
                            "--"
                          )
                        }
                        style={{ width: "20%" }}
                        className="table_column text-end"
                      ></Column>
                    </DataTable>
                  </article>

                  {section.sub_section_data?.map((subSection) => {
                    // const unitPriceTotalSubSection = calculateUnitPriceTotal(subSection?.sub_section_item_data || []);
                    // const multiplePriceTotalSubSection = calculateMultiplePriceTotal(subSection?.sub_section_item_data || []);

                    const unitPriceTotalSubSection =
                      calculateSubSectionItemUnitPriceTotal(
                        subSection.sub_section_item_data
                      );
                    const multiplePriceTotalSubSection =
                      calculateSubSectionItemPriceTotal(
                        subSection.sub_section_item_data
                      );

                    return (
                      <React.Fragment>
                        {subSection.sub_section_item_data?.length !== 0 && (
                          <article
                            id={`subsection${subSection?.sub_section_no}`}
                            key={section.section_id}
                            className="main_section_area"
                          >
                            <div className="main_section_header">
                              <h6>
                                Section {section?.section_no}. (
                                {subSection?.sub_section_no +
                                  " " +
                                  subSection?.sub_section_name}
                                ){" "}
                              </h6>
                            </div>

                            <DataTable
                              value={subSection.sub_section_item_data}
                              size="small"
                              tableStyle={{ minWidth: "50rem" }}
                              className="page_table project_table view_only p-0 p-sm-2"
                              tableClassName="mb-1"
                              rowClassName={getRowClassName}
                              dataKey="item_id"
                              metaKeySelection={false}
                              scrollable
                              scrollHeight={"75vh"}
                              editMode="cell"
                              emptyMessage="No data found"
                              footerColumnGroup={
                                <ColumnGroup>
                                  <Row>
                                    <Column
                                      footer="Sub total:"
                                      colSpan={3}
                                      className="table_column text_no_wrap text-center"
                                    />
                                    <Column
                                      footer={`${currencySymbol} ${formatPrice(
                                        unitPriceTotalSubSection
                                      )}`}
                                      className="table_column text_no_wrap text-end"
                                    />
                                    <Column
                                      footer={`${currencySymbol} ${formatPrice(
                                        multiplePriceTotalSubSection
                                      )}`}
                                      className="table_column text_no_wrap text-end"
                                    />
                                    <Column className="table_column" />
                                  </Row>
                                </ColumnGroup>
                              }
                            >
                              <Column
                                header="Item no."
                                alignHeader={"center"}
                                body={(rowData: SowSubSectionItemData) =>
                                  rowData.item_no ? (
                                    <span className="flex_center">
                                      {rowData.item_no}
                                    </span>
                                  ) : (
                                    "--"
                                  )
                                }
                                style={{ width: "8%" }}
                                className="table_column pointer-event-none"
                              ></Column>

                              <Column
                                header="Item name"
                                body={(rowData: SowSubSectionItemData) =>
                                  rowData.item_name ? (
                                    <span>{rowData.item_name}</span>
                                  ) : (
                                    "--"
                                  )
                                }
                                style={{ width: "30%" }}
                                className="table_column pointer-event-none"
                              ></Column>

                              <Column
                                header="Unit no."
                                alignHeader={"center"}
                                style={{ width: "8%" }}
                                field="unit_no"
                                body={(rowData: SowSubSectionItemData) =>
                                  rowData.item_amount_data?.unit_no !== 0 ? (
                                    <span className="flex_center text_no_wrap">
                                      {rowData.item_amount_data?.unit_no}
                                    </span>
                                  ) : (
                                    <span className="flex_center">--</span>
                                  )
                                }
                                className={`table_column column_editable text-center column_as_input ${isEditable ? "editable" : "pointer-event-none"
                                  }`}
                                editor={(options) =>
                                  subSectionItemEditor(options)
                                }
                                onCellEditComplete={subSectionItemEditComplete}
                              ></Column>

                              <Column
                                header="Unit price"
                                alignHeader={"right"}
                                style={{ width: "12%" }}
                                field="unit_price"
                                body={(rowData: SowSubSectionItemData) => (
                                  <span className="flex_end text_no_wrap">
                                    {currencySymbol}&nbsp;
                                    {formatPrice(
                                      rowData.item_amount_data?.unit_price!
                                    )}
                                  </span>
                                )}
                                editor={(options) =>
                                  subSectionItemEditor(options)
                                }
                                onCellEditComplete={subSectionItemEditComplete}
                                className={`table_column column_editable column_as_input text-end ${isEditable ? "editable" : "pointer-event-none"
                                  }`}
                              ></Column>

                              <Column
                                header="Multiple price"
                                alignHeader={"right"}
                                style={{ width: "12%" }}
                                body={(rowData: SowSubSectionItemData) => (
                                  <span className="flex_end text_no_wrap">
                                    {currencySymbol}&nbsp;
                                    {formatPrice(
                                      rowData.item_amount_data?.total!
                                    )}
                                  </span>
                                )}
                                className="table_column text-end pointer-event-none"
                              ></Column>

                              <Column
                                header="Note"
                                alignHeader={"center"}
                                style={{ width: "28%" }}
                                className={`table_column column_as_input ${isEditable && "editable"
                                  }`}
                                field="note"
                                body={(rowData: SowSubSectionItemData) => (
                                  <span
                                    className={`flex_center text-center ${!isEditable &&
                                        rowData.item_amount_data?.note !== ""
                                        ? "cursor_pointer"
                                        : "pointer-event-none"
                                      }`}
                                    onClick={() =>
                                      !isEditable &&
                                      rowData.item_amount_data?.note !== "" &&
                                      handleViewNote(
                                        rowData.item_amount_data?.note!
                                      )
                                    }
                                  >
                                    {rowData.item_amount_data?.note
                                      ? rowData.item_amount_data?.note
                                      : "--"}
                                  </span>
                                )}
                                editor={
                                  isEditable
                                    ? (options) => subSectionItemEditor(options)
                                    : undefined
                                }
                                onCellEditComplete={
                                  isEditable
                                    ? subSectionItemEditComplete
                                    : undefined
                                }
                              ></Column>
                            </DataTable>
                          </article>
                        )}
                      </React.Fragment>
                    );
                  })}
                </React.Fragment>
              )}

              {section?.section_item_data?.length !== 0 && (
                <React.Fragment>
                  <article
                    id={`section${section?.section_no}`}
                    key={section.section_id}
                    className="main_section_area"
                  >
                    <div className="main_section_header">
                      <h6>
                        {section?.section_no}.&nbsp;{section.section_name}
                      </h6>
                    </div>

                    <DataTable
                      value={section?.section_item_data}
                      size="small"
                      tableStyle={{ minWidth: "50rem" }}
                      className="page_table project_table view_only p-0 p-sm-2"
                      tableClassName="mb-1"
                      rowClassName={getRowClassName}
                      metaKeySelection={false}
                      scrollable
                      scrollHeight={"75vh"}
                      emptyMessage="No data found"
                      dataKey="item_id"
                      editMode="cell"
                      footerColumnGroup={
                        <ColumnGroup>
                          <Row>
                            <Column
                              footer="Sub total:"
                              colSpan={3}
                              className="table_column text_no_wrap text-center"
                            />
                            <Column
                              footer={`${currencySymbol} ${formatPrice(
                                unitPriceTotalSection
                              )}`}
                              className="table_column text_no_wrap text-end"
                            />
                            <Column
                              footer={`${currencySymbol} ${formatPrice(
                                multiplePriceTotalSection
                              )}`}
                              className="table_column text_no_wrap text-end"
                            />
                            <Column className="table_column" />
                          </Row>
                        </ColumnGroup>
                      }
                    >
                      <Column
                        header="Item no."
                        alignHeader={"center"}
                        body={(rowData: SowSectionItemData) =>
                          rowData.item_no ? (
                            <span className="flex_center">
                              {rowData.item_no}
                            </span>
                          ) : (
                            "--"
                          )
                        }
                        style={{ width: "8%" }}
                        className="table_column pointer-event-none"
                      ></Column>

                      <Column
                        header="Item name"
                        body={(rowData: SowSectionItemData) =>
                          rowData.item_name ? (
                            <span>{rowData.item_name}</span>
                          ) : (
                            "--"
                          )
                        }
                        style={{ width: "30%" }}
                        className="table_column pointer-event-none"
                      ></Column>

                      <Column
                        header="Unit no."
                        alignHeader={"center"}
                        style={{ width: "8%" }}
                        field="unit_no"
                        body={(rowData: SowSectionItemData) =>
                          rowData.item_amount_data!.unit_no ? (
                            <span className="flex_center text_no_wrap">
                              {rowData.item_amount_data!.unit_no}
                            </span>
                          ) : (
                            <span className="flex_center">--</span>
                          )
                        }
                        className={`table_column column_editable text-center column_as_input  ${isEditable ? "editable" : "pointer-event-none"
                          }`}
                        editor={
                          isEditable
                            ? (options) => sectionItemEditor(options)
                            : undefined
                        }
                        onCellEditComplete={
                          isEditable ? sectionItemEditComplete : undefined
                        }
                      ></Column>

                      <Column
                        header="Unit price"
                        alignHeader={"right"}
                        style={{ width: "12%" }}
                        field="unit_price"
                        body={(rowData: SowSectionItemData) => (
                          <span className="flex_end text_no_wrap">
                            {currencySymbol}&nbsp;
                            {formatPrice(rowData.item_amount_data!.unit_price)}
                          </span>
                        )}
                        editor={
                          isEditable
                            ? (options) => sectionItemEditor(options)
                            : undefined
                        }
                        onCellEditComplete={
                          isEditable ? sectionItemEditComplete : undefined
                        }
                        className={`table_column column_editable column_as_input text-end  ${isEditable ? "editable" : "pointer-event-none"
                          }`}
                      ></Column>

                      <Column
                        header="Multiple price"
                        alignHeader={"right"}
                        body={(rowData: SowSectionItemData) => (
                          <span className="flex_end text_no_wrap">
                            {currencySymbol}&nbsp;
                            {formatPrice(rowData.item_amount_data!.total!)}
                          </span>
                        )}
                        style={{ width: "12%" }}
                        className="table_column text-end pointer-event-none"
                      ></Column>

                      <Column
                        header="Note"
                        alignHeader={"center"}
                        style={{ width: "28%" }}
                        className={`table_column column_as_input ${isEditable && "editable"
                          }`}
                        field="note"
                        body={(rowData: SowSectionItemData) => (
                          <span
                            className={`flex_center text-center ${!isEditable &&
                                rowData.item_amount_data!.note !== ""
                                ? "cursor_pointer"
                                : "pointer-event-none"
                              }`}
                            onClick={() =>
                              !isEditable &&
                              rowData.item_amount_data!.note !== "" &&
                              handleViewNote(rowData.item_amount_data!.note!)
                            }
                          >
                            {rowData.item_amount_data!.note
                              ? rowData.item_amount_data!.note
                              : "--"}
                          </span>
                        )}
                        editor={
                          isEditable
                            ? (options) => sectionItemEditor(options)
                            : undefined
                        }
                        onCellEditComplete={
                          isEditable ? sectionItemEditComplete : undefined
                        }
                      ></Column>
                    </DataTable>
                  </article>
                </React.Fragment>
              )}
            </React.Fragment>
          );
        })}

        {preliminariesData?.length > 0 && (
          <article id="preliminary" className="main_section_area">
            <div className="main_section_header">
              <h6>Preliminaries</h6>
            </div>
            <DataTable
              value={preliminariesData}
              size="small"
              tableStyle={{ minWidth: "50rem" }}
              className="page_table project_table view_only p-0 p-sm-2"
              tableClassName="mb-1"
              rowClassName={getRowClassName}
              metaKeySelection={false}
              scrollable
              scrollHeight={"75vh"}
              emptyMessage="No data found"
              dataKey="priliminiery_id"
              editMode="cell"
              footerColumnGroup={
                <ColumnGroup>
                  <Row>
                    <Column
                      footer="Sub total:"
                      colSpan={3}
                      className="table_column text_no_wrap text-center"
                    />
                    <Column
                      footer={`${currencySymbol} ${formatPrice(
                        unitPriceTotalPreliminaries
                      )}`}
                      className="table_column text_no_wrap text-end"
                    />
                    <Column
                      footer={`${currencySymbol} ${formatPrice(
                        multiplePriceTotalPreliminaries
                      )}`}
                      className="table_column text_no_wrap text-end"
                    />
                    <Column className="table_column" />
                  </Row>
                </ColumnGroup>
              }
            >
              <Column
                header="Ref no."
                alignHeader={"center"}
                body={(rowData: Priliminary) =>
                  rowData.ref_number ? (
                    <span className="flex_center">{rowData.ref_number}</span>
                  ) : (
                    "--"
                  )
                }
                style={{ width: "8%" }}
                className="table_column pointer-event-none"
              ></Column>

              <Column
                header="Item name"
                body={(rowData: Priliminary) =>
                  rowData.item_name ? <span>{rowData.item_name}</span> : "--"
                }
                style={{ width: "30%" }}
                className="table_column pointer-event-none"
              ></Column>

              <Column
                header="Unit no."
                alignHeader={"center"}
                style={{ width: "8%" }}
                field="unit_no"
                body={(rowData: Priliminary) =>
                  rowData.priliminiery_amount_data!.unit_no !== 0 ? (
                    <span className="flex_center text_no_wrap">
                      {rowData.priliminiery_amount_data!.unit_no}
                    </span>
                  ) : (
                    <span className="flex_center">--</span>
                  )
                }
                className={`table_column column_editable text-center column_as_input ${isEditable ? "editable" : "pointer-event-none"
                  }`}
                editor={
                  isEditable
                    ? (options) => preliminaryItemEditor(options)
                    : undefined
                }
                onCellEditComplete={
                  isEditable ? preliminaryItemEditComplete : undefined
                }
              ></Column>

              <Column
                header="Unit price"
                alignHeader={"right"}
                style={{ width: "12%" }}
                field="unit_price"
                body={(rowData: Priliminary) => (
                  <span className="flex_end text_no_wrap">
                    {currencySymbol}&nbsp;
                    {formatPrice(rowData.priliminiery_amount_data!.unit_price)}
                  </span>
                )}
                className={`table_column column_editable column_as_input text-end ${isEditable ? "editable" : "pointer-event-none"
                  }`}
                editor={
                  isEditable
                    ? (options) => preliminaryItemEditor(options)
                    : undefined
                }
                onCellEditComplete={
                  isEditable ? preliminaryItemEditComplete : undefined
                }
              ></Column>

              <Column
                header="Multiple price"
                alignHeader={"right"}
                style={{ width: "12%" }}
                body={(rowData: Priliminary) => (
                  <span className="flex_end text_no_wrap">
                    {currencySymbol}&nbsp;
                    {formatPrice(rowData.priliminiery_amount_data!.total!)}
                  </span>
                )}
                className="table_column text-end pointer-event-none"
              ></Column>

              <Column
                header="Note"
                alignHeader={"center"}
                style={{ width: "28%" }}
                className={`table_column column_as_input ${isEditable && "editable"
                  }`}
                field="note"
                body={(rowData: Priliminary) => (
                  <span
                    className={`flex_center text-center ${!isEditable &&
                        rowData.priliminiery_amount_data!.note !== ""
                        ? "cursor_pointer"
                        : "pointer-event-none"
                      }`}
                    onClick={() =>
                      !isEditable &&
                      rowData.priliminiery_amount_data!.note !== "" &&
                      handleViewNote(rowData.priliminiery_amount_data!.note!)
                    }
                  >
                    {rowData.priliminiery_amount_data!.note
                      ? rowData.priliminiery_amount_data!.note
                      : "--"}
                  </span>
                )}
                editor={
                  isEditable
                    ? (options) => preliminaryItemEditor(options)
                    : undefined
                }
                onCellEditComplete={
                  isEditable ? preliminaryItemEditComplete : undefined
                }
              ></Column>
            </DataTable>
          </article>
        )}
      </div>

      {/* Download modal */}

      <DocumentDownload
        isOpen={showDownloadModal}
        onClose={() => setShowDownloadModal(false)}
        title="Schedule of work"
        fileUrl={downloadFilePath}
      />

      {/* Note view modal */}
      <NoteViewModal
        isOpen={showNoteViewModal}
        onClose={handleCloseNoteView}
        note={note}
      />

      {/* Compare tender list modal */}
      <Dialog
        visible={showCompareModal}
        header={compareModalHeader}
        footer={compareModalFooter}
        headerClassName="custom_modal_header"
        className="custom_modal_dialog modal_dialog_md"
        onHide={handleCloseCompareModal}
        dismissableMask
      >
        <div className="custom_modal_body">
          <div className="row">
            <div className="col-12">
              <label className={`custom_form_label mb-2`}>
                Select the builder(s)
              </label>
              {tenderList?.map((builder) => (
                <div
                  className="option_checkbox_area"
                  key={builder.tender_part_share_id}
                >
                  <article
                    className={`shared_contact_body mb-0 ${isCheckedCompare(builder) && "selected"
                      }`}
                  >
                    <h6>{(builder.company_name !== null) ? builder.company_name : builder.first_name + " " + builder.last_name}</h6>
                  </article>
                  <Checkbox
                    onChange={(e) =>
                      handleCheckToCompare(builder, e.checked || false)
                    }
                    checked={isCheckedCompare(builder)}
                  ></Checkbox>
                </div>
              ))}
            </div>
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default TenderList;
